import { render, staticRenderFns } from "./photo.vue?vue&type=template&id=1e4d944f&scoped=true"
import script from "./photo.vue?vue&type=script&lang=ts"
export * from "./photo.vue?vue&type=script&lang=ts"
import style0 from "./photo.vue?vue&type=style&index=0&id=1e4d944f&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e4d944f",
  null
  
)

export default component.exports